import {db, storage}  from '../../firebase/firebase.config';
import firebase from 'firebase';
import React,{useState,useEffect} from 'react';
import {
  PricingSection,
  PricingWrapper,
  PricingHeading,
  PricingContainer,
  PricingCard,
  PricingContainerph,
PricingCardph,
Img,
PricingHeadingph
} from './projects.elements';
import a1 from '../../images/1.jpeg';
import a2 from '../../images/2.jpeg';
import a3 from '../../images/3.jpeg';
import a4 from '../../images/4.jpeg';
import a5 from '../../images/5.jpeg';
import a6 from '../../images/6.jpeg';
import a7 from '../../images/7.jpeg';
import a8 from '../../images/8.jpeg';
import a9 from '../../images/9.jpeg';
import e1 from '../../images/e1.jpeg';
import e2 from '../../images/e2.jpeg';
import e3 from '../../images/e3.jpeg';
import e111 from '../../images/111.jpg';
import e1111 from '../../images/1111.jpg';
import e11111 from '../../images/11111.jpg';

function Projects() {

 

  return (
   

      <PricingSection>
        <PricingWrapper>
          <PricingHeading style={{ fontSize: '50px' }}> Sponsers</PricingHeading>

    <PricingContainerph>
    
            <PricingCardph>
                          <Img  src= { a1 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
              <PricingCardph>
                          <Img  src= { a2 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
              <PricingCardph>
                          <Img  src= { a3 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
              <PricingCardph>
                          <Img  src= { a4 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
              <PricingCardph>
                          <Img  src= { a5 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
              <PricingCardph>
                          <Img  src= { a6 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
              <PricingCardph>
                          <Img  src= { a7 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
              <PricingCardph>
                          <Img  src= { a8 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
              <PricingCardph>
                          <Img  src= { a9 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
      
          </PricingContainerph>  
          
         
        </PricingWrapper>

<PricingWrapper>
          <PricingHeading style={{ fontSize: '50px' }}>فـريـق العمـل</PricingHeading>

    <PricingContainerph>
    
            <PricingCardph>
                          <Img  src= { e1 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
              <PricingCardph>
                          <Img  src= { e2 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
           <PricingCardph>
                          <Img  src= { e3 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
        <PricingCardph>
                          <Img  src= { e111 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
              <PricingCardph>
                          <Img  src= { e1111 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
              <PricingCardph>
                          <Img  src= { e11111 } />
              {/* <PricingHeadingph>{projectwithphoto.title}</PricingHeadingph> */}
            </PricingCardph>
          </PricingContainerph>  
          
         
        </PricingWrapper>

      </PricingSection>
  );
}

export default Projects;
